/**
 * @generated SignedSource<<717b08c84cc3ed854830f45711a3753e>>
 * @relayHash 9bae80de520f41e90fdcf9800d184eaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c4044688765a749a9507acaf9d7c807142e2b1564aea50c76fc2ecf3b608b74

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateContentPropertyPageUpdateMutation$variables = {
  pageId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateContentPropertyPageUpdateMutation$data = {
  readonly confluence: {
    readonly updateValuePageProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateContentPropertyPageUpdateMutation = {
  response: useUpdateContentPropertyPageUpdateMutation$data;
  variables: useUpdateContentPropertyPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
        "kind": "LinkedField",
        "name": "updateValuePageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "pageProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "9bae80de520f41e90fdcf9800d184eaf",
    "id": "5c4044688765a749a9507acaf9d7c807142e2b1564aea50c76fc2ecf3b608b74",
    "metadata": {},
    "name": "useUpdateContentPropertyPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentPropertyPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{key,value},errors{message}}}}"
  }
};
})();

(node as any).hash = "89097e7c530ad5ccbea1f9d3235ef18b";

export default node;
